window.swiperInstances = {};

class SwiperCustomElement extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.sectionId =
      this.getAttribute("data-section-id") ||
      `section-${Math.random().toString(36).substr(2, 5)}`;
    this.namespace = ".swiper__" + this.sectionId;

    this.perviewDesktop = this.getAttribute("data-perview-desktop") || 3;
    this.perviewTablet = this.getAttribute("data-perview-tablet") || 2.2;
    this.perviewMobile = this.getAttribute("data-perview-mobile") || 1.3;
    this.spaceBetweenDesktop = this.getAttribute("data-space-desktop") || 20;
    this.spaceBetweenMobile = this.getAttribute("data-space-mobile") || 10;
    this.centeredSlides = this.getAttribute("data-centered-slides");
    this.autoHeight = this.getAttribute("data-autoheight");
    this.autoplay = this.getAttribute("data-autoplay");
    this.sliderEffect = this.getAttribute("data-effect") || "none";

    this.swiper = null;

    console.log('this.centeredSlides');
    console.log(this.centeredSlides);
  }

  connectedCallback() {
    this.style.opacity = "0";
    this.initObserver();
    window.swiperInstances[this.sectionId] = this;
  }

  initObserver() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.initSwiper();
            observer.unobserve(this);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this);
  }

  initSwiper() {
    this.swiper = new Swiper(this.namespace, {
      slidesPerView: this.perviewMobile,
      freeMode: false,
      slidesPerGroup: 1,
      autoHeight: this.autoHeight ? true : false,
      freeModeSticky: false,
      centeredSlides: this.centeredSlides ? true : false,
      grabCursor: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preloadImages: true,
      updateOnImagesReady: true,
      spaceBetween: this.spaceBetweenMobile,
      observer: true,
      observeParents: true,
      loop: this.autoplay ? true : false,
      slideToClickedSlide: true,
      allowTouchMove: true,
      autoplay: this.autoplay
        ? {
            delay: parseInt(this.autoplay),
            disableOnInteraction: true,
          }
        : false,
      effect: this.sliderEffect,
      breakpoints: {
        1024: {
          slidesPerView: this.perviewDesktop,
          spaceBetween: this.spaceBetweenDesktop,
        },
        749: {
          slidesPerView: this.perviewTablet,
          spaceBetween: this.spaceBetweenDesktop,
        },
      },
      scrollbar: {
        el: this.querySelector(".swiper-scrollbar"),
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        init: () => {
          this.style.opacity = "1";
        },
      },
    });

    window.swiperInstances[this.sectionId].swiper = this.swiper;
  }
}

customElements.define("swiper-custom", SwiperCustomElement);
